import script from "./ExternalAgreementConfView.vue?vue&type=script&setup=true&lang=js"
export * from "./ExternalAgreementConfView.vue?vue&type=script&setup=true&lang=js"

import "./ExternalAgreementConfView.vue?vue&type=style&index=0&id=165a2ace&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-165a2ace"]])

export default __exports__